import { render, staticRenderFns } from "./CaseShare.vue?vue&type=template&id=28ee5d74&scoped=true"
import script from "./CaseShare.vue?vue&type=script&lang=js"
export * from "./CaseShare.vue?vue&type=script&lang=js"
import style0 from "./CaseShare.vue?vue&type=style&index=0&id=28ee5d74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ee5d74",
  null
  
)

export default component.exports